<template>
  <div style="height: 100%;width: 100%;background-color: white;overflow: hidden">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%;">
        <el-col :span="24" style="height: 100%;overflow-y: auto">
          <div style="height: 100%;margin: 0 20px">
            <div style="max-height: calc(100% - 50px);overflow-y: auto">
              <el-table :data="showTable" style="width: 100%" highlight-current-row ref="singleTable" border :key="tableKey">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="p_name" label="服务对象" min-width="70" align="center"></el-table-column>
                <el-table-column label="所属区域" min-width="90" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.homeObj">{{scope.row.homeObj.orglevelname}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="家庭地址" min-width="120" align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.h_address}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="事件类型" min-width="110">
                  <template slot-scope="scope">
                    <img style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImgAlarm(scope.row.alarmtype)">
                    <span>{{getAType(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="alarmphone" label="呼入号码" min-width="80" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.alarmtype === 'phonein'">{{scope.row.alarmphone}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="time" label="事件时间" min-width="140"></el-table-column>
                <el-table-column align="center" label="设备编号" min-width="140">
                  <template slot-scope="scope">
                    <span v-if="scope.row.device">{{scope.row.device.deviceid}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="设备类型" min-width="126" align="center">
                  <template slot-scope="scope">
                    <img v-if="scope.row.device && (scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein')" style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImg(scope.row.device.devicetype)">
                    <span v-if="scope.row.device && (scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein')">{{getDeviceType(scope.row.device.devicetype)}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="设备号码" min-width="140">
                  <template slot-scope="scope">
                    <span v-if="scope.row.device">{{getDevicePhone(scope.row.device)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="设备标识"
                  min-width="140">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sub_deviceid !== '' && scope.row.subdevice && scope.row.subdevice.remark !== ''"><span v-if="scope.row.subdevice">{{scope.row.subdevice.remark}}</span></span>
                    <span v-else><span v-if="scope.row.device">{{scope.row.device.h_installlocation}}</span></span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button size="small" type="warning" :disabled="!(!scope.row.buttondisable)" @click="handleChangeNew(scope.row)">现在处理</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="处理信息"  align="center" min-width="120">
                  <template slot-scope="scope">
                    <div style="color: #e64d00" v-if="scope.row.handleuesrname === '未处理'">
                      <img src="../../assets/handlealarm/event_icon_not.png" style="vertical-align: middle;width: 16px">
                      <strong>{{scope.row.handleuesrname}}</strong>
                    </div>
                    <div style="color: #00bfff" v-else-if="scope.row.handleuesrname === '继续处理'">
                      <img src="../../assets/handlealarm/event_icon_continue.png" style="vertical-align: middle;width: 16px">
                      <strong>{{scope.row.handleuesrname}}</strong>
                    </div>
                    <div style="color: #e5a015" v-else>
                      <img src="../../assets/handlealarm/event_icon_major.png" style="vertical-align: middle;width: 16px">
                      <strong>{{scope.row.handleuesrname}}</strong>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="text-align: center;margin-top: 10px;height: 40px;">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog top="5vh" :visible.sync="handleAlarmShow" v-if="handleAlarmShow" width="1250px"
      :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" class="alarm-detail">
      <do-handle-alarm :handleAlarmRow="changeRow"  @getFatherHandle="getFatherHandle"></do-handle-alarm>
    </el-dialog>
  </div>
</template>

<script>
import doHandleAlarm from '../datamanagement/childComponents/doHandleAlarm'
import {queryunhanlealarm, queryoldpersonbypids, queryhomebyhids, queryunhanlealarmbyalarmid} from '../../api/handlealarm'
import {querydevicebydids} from '../../api/device'
import {
  querysupplierorgnotype,
  querysupplierservice,
  querysuppliertype
} from '../../api/serviceMark'
import {queryproject, queryfrequency} from '../../api/serviceObject'
import {sendSub} from '../../mq'
import {queryorgcommunity} from '../../api/community'

export default {
  name: 'handleAlarm',
  components: {doHandleAlarm},
  data () {
    return {
      imgIcon: [],
      tableData: [],
      showTable: [],
      tableKey: 0,
      handleIDList: [],
      handleUsernameList: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      handleAlarmShow: false,
      changeRow: {
        isPhonein: false,
        oldPerson: '',
        row: {},
        types: [], // 服务类型
        supplierorg: [], // 服务商
        projects: [],
        frequencys: [],
        typeOrg: [], // 服务内容
        orgcommunitys: [],
        alarmOrder: '' // 转让订单的信息
      },
      dids: [],
      devices: [],
      isDevice: true,
      hids: [],
      homes: [],
      pids: [],
      oldpersons: [],
      orgid: '',
      projects: [],
      frequencys: [],
      typeOrg: [],
      imgIconAlarm: []
    }
  },
  created () {
    this.golobleObject.updateTableAlarm = this.mqttHandle
    this.golobleObject.getHandleInfo = this.changeShow
    this.golobleObject.updateAlarmById = this.getAlarmById
    this.orgid = this.$store.state.user.orgid
    this.imgIcon = this.getImgArr.getImgIconDevice()
    this.imgIconAlarm = this.getImgArr.getImgIconAlarm()
    this.getCommunityData()
    this.getFrequency()
    this.querySupplier()
  },
  mounted () {
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    // 查询频率
    getFrequency () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.changeRow.frequencys = res.data.frequencys
      }).catch(() => {})
    },
    // 所属小区
    getCommunityData () {
      queryorgcommunity().then(res => {
        this.changeRow.orgcommunitys = res.data.orgcommunitys
      }).catch(() => {})
    },
    // 服务商
    querySupplier () {
      let params = {
        page: 1,
        size: 9999
      }
      querysupplierorgnotype(params).then(res => {
        this.changeRow.supplierorg = res.data.org
        this.querySupplierTypeData()
      }).catch(() => {})
    },
    // 服务类型
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.changeRow.types = res.data.types
        this.querySupplierAndType()
      }).catch(() => {})
    },
    // 服务内容
    querySupplierAndType () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierservice(params).then(res => {
        this.typeOrg = res.data.service
        this.changeRow.typeOrg = res.data.service
        this.getProjects()
      }).catch(() => {})
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.orgid
      }
      queryproject(data).then(res => {
        this.projects = res.data.projects
        this.changeRow.projects = this.projects
        this.mqttHandleAlarm()
      }).catch(() => {
        this.loading = false
      })
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.h_phone !== '') {
          return row.h_phone
        } else {
          return row.p_phone
        }
      }
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getProjectName (person) {
      for (let i = 0; i < this.projects.length; i++) {
        if (person.projectid === this.projects[i].id) {
          return this.projects[i].projectname
        }
      }
    },
    getTypeImg (type) {
      let url = this.imgIcon[0].imgUrl
      for (let i = 0; i < this.imgIcon.length; i++) {
        if (type === this.imgIcon[i].dtype) {
          url = this.imgIcon[i].imgUrl
        }
      }
      return url
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    // mqtt收到报警
    mqttHandle () {
      if (this.showTable.length === 1) {
        if (this.currentPage !== 1) {
          this.currentPage -= 1
        }
      }
      this.mqttHandleAlarm()
    },
    // 表格数据
    mqttHandleAlarm () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryunhanlealarm(params).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
        let oldDids = this.dids.length
        this.hids = []
        this.pids = []
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].h_hid !== 0) {
            this.hids.push(this.tableData[i].h_hid)
          }
          if (this.tableData[i].p_pid !== 0) {
            this.pids.push(this.tableData[i].p_pid)
          }
          if (this.dids.indexOf(this.tableData[i].did) === -1) {
            this.dids.push(this.tableData[i].did)
          }
        }
        if (oldDids === this.dids.length) {
          this.isDevice = false
        } else {
          this.isDevice = true
        }
        this.getOldPerson()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务对象信息
    getOldPerson () {
      if (this.pids.length > 0) {
        let data = {
          pids: this.pids
        }
        queryoldpersonbypids(data).then(res => {
          this.oldpersons = res.data.persons
          this.getHomeData()
        }).catch(() => {})
      } else {
        this.getHomeData()
      }
    },
    // 家信息
    getHomeData () {
      if (this.hids.length > 0) {
        let data = {
          hids: this.hids
        }
        queryhomebyhids(data).then(res => {
          this.homes = res.data.homes
          this.getDevices()
        }).catch(() => {})
      } else {
        this.getDevices()
      }
    },
    // 设备
    getDevices () {
      if (this.isDevice) {
        let data = {
          dids: this.dids
        }
        querydevicebydids(data).then(res => {
          this.devices = this.devices.concat(res.data.devices)
          this.getDeviceTable()
        }).catch(() => {})
      } else {
        this.getDeviceTable()
      }
    },
    getDeviceTable () {
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        for (let j = 0; j < this.devices.length; j++) {
          if (tempList[i].did === this.devices[j].id) {
            tempList[i].device = this.devices[j]
            if (tempList[i].sub_deviceid !== '') {
              this.devices[j].sub_devices.forEach(sub => {
                if (tempList[i].sub_deviceid === sub.sub_deviceid) {
                  tempList[i].subdevice = sub
                }
              })
            }
          }
        }
      }
      this.tableData = tempList
      this.changeShow()
    },
    changeShow () {
      this.showTable = []
      // console.log(666, this.store2.state.other.isHandle)
      let handle = this.store2.state.other.isHandle
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].buttondisable = false
        this.tableData[i].handleuesrname = '未处理'
        if (this.tableData[i].prehandle > 0) {
          this.tableData[i].handleuesrname = '继续处理'
        }
        for (let j = 0; j < handle.length; j++) {
          if (handle[j].id === this.tableData[i].id) {
            this.tableData[i].buttondisable = true
            this.tableData[i].handleuesrname = handle[j].name + '正在处理'
          }
        }
        if (this.tableData[i].alarmtype !== 'phonein') {
          if (this.tableData[i].h_hid !== 0) {
            for (let j = 0; j < this.homes.length; j++) {
              if (this.tableData[i].h_hid === this.homes[j].id) {
                this.tableData[i].h_address = this.homes[j].address
                this.tableData[i].p_name = (this.homes[j].OldPerson && this.homes[j].OldPerson[0]) ? this.homes[j].OldPerson[0].name : ''
                // this.tableData[i].p_name = this.homes[j].OldPerson?[0]?name || ''
                this.tableData[i].homeObj = this.homes[j]
              }
            }
          }
          if (this.tableData[i].p_pid !== 0) {
            for (let j = 0; j < this.oldpersons.length; j++) {
              if (this.tableData[i].p_pid === this.oldpersons[j].id) {
                this.tableData[i].p_name = this.oldpersons[j].name
                this.tableData[i].h_address = this.oldpersons[j].h_address
              }
            }
          }
        }
      }
      this.tableKey++
      this.showTable = this.tableData
      console.log('endlist', this.tableData)
    },
    getTypeImgAlarm (type) {
      let num = this.commonType.getAlarmTypeIcon(type)
      return this.imgIconAlarm[num].imgUrl
    },
    getAType (row) {
      return this.commonType.getAlarmType(row.alarmtype)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    handleChangeNew (row) {
      let mqtts = this.$store.state.user.mqtts
      this.changeRow.alarmOrder = ''
      // console.log(row)
      let name = this.$store.state.user.personname
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      let jobnum = this.$store.state.user.syspersonjobnum
      let dohandle = {id: row.id, name: name, time: date, jobnum: jobnum}
      sendSub('/handlealarm' + mqtts[0], JSON.stringify(dohandle))
      if (row.alarmtype !== 'phonein') {
        this.changeRow.row = row
        this.handleAlarmShow = true
      } else {
        // console.log(11, this.changeRow)
        let obj = {
          alarmRow: row,
          types: this.changeRow.types,
          supplierorg: this.changeRow.supplierorg,
          typeOrg: this.changeRow.typeOrg,
          projects: this.changeRow.projects,
          orgcommunitys: this.changeRow.orgcommunitys
        }
        this.golobleObject.openPhoneCall(obj)
      }
    },
    getFatherHandle (obj) {
      if (obj.type === 'close') {
        this.handleAlarmShow = false
      }
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      this.mqttHandleAlarm()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.mqttHandleAlarm()
    },
    getAlarmById (alarmOrder) {
      this.changeRow.alarmOrder = alarmOrder
      let data = {
        alarmid: alarmOrder.alarmid
      }
      queryunhanlealarmbyalarmid(data).then(res => {
        // alarm
        let alarm = res.data.alarm[0]
        this.getAlarmByIdDevice(alarm)
      }).catch(() => {})
    },
    getAlarmByIdDevice (alarm) {
      let mqtts = this.$store.state.user.mqtts
      let alarm1 = alarm
      let data = {
        dids: [alarm.did]
      }
      querydevicebydids(data).then(res => {
        alarm1.device = res.data.devices[0]
        this.changeRow.row = alarm1
        let name = this.$store.state.user.personname
        // eslint-disable-next-line no-extend-native
        Date.prototype.format = this.validate.format
        const date = new Date().format('yyyy-MM-dd hh:mm:ss')
        let jobnum = this.$store.state.user.syspersonjobnum
        let dohandle = {id: alarm1.id, name: name, time: date, jobnum: jobnum}
        sendSub('/handlealarm' + mqtts[0], JSON.stringify(dohandle))
        this.handleAlarmShow = true
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/handlealarm/index.vue